import { useState, useRef, useEffect } from "react";
import {
  TextField,
  Button,
  Typography,
  FormGroup,
  Checkbox,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  Grid,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useFormik } from "formik";
import { validationSchema } from "./validations";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const initialValues = {
  email: "",
  sobrenome: "",
  nome: "",
  descricao: "",
  redeSocial: "",
  multiplaSelecao: [],
  linguagemProgramacaoSimples: "",
  linguagemProgramacao: "",
  ferramentas: {
    selenium: false,
    appium: false,
    robotFramework: false,
    cypress: false,
  },
};

export const FormularioQA = () => {
  const [disabledForm, setDisabledForm] = useState(false);
  const nomeRef = useRef(null);

  const [file, setFile] = useState({
    value: "",
    blob: null,
  });
  useEffect(() => {
    if (!disabledForm) {
      nomeRef.current.focus();
    }
  }, [disabledForm]);
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      if (values) {
        setFile({
          value: "",
          blob: null,
        });
        resetForm();
        setDisabledForm(true);
        toast.success(
          "Dados enviados com sucesso. Clique no botão RESETAR para reiniciar o formulário.",
          {
            position: "top-right",
            icon: true,
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      }
    },
  });

  return (
    <Grid container justifyContent="center">
      <Grid container lg={8} style={{ padding: 50 }}>
        <Grid container style={{ paddingBottom: 20 }}>
          <Typography variant="h4">
            Mentoria de Automação - Formulário de teste
          </Typography>
        </Grid>
        <Typography variant="h6">1. Exemplo campos de texto: </Typography>

        <form onSubmit={formik.handleSubmit}>
          <Grid container lg={12} spacing={2}>
            <Grid item lg={6} md={6} xs={12} style={{ paddingBottom: 20 }}>
              <TextField
                fullWidth
                inputProps={{ id: "id_campo_nome", ref: nomeRef }}
                name="nome"
                label="Nome"
                disabled={disabledForm}
                value={formik.values.nome}
                onChange={formik.handleChange}
                error={formik.touched.nome && Boolean(formik.errors.nome)}
                helperText={formik.touched.nome && formik.errors.nome}
              />
            </Grid>
            <Grid item lg={6} md={6} xs={12} style={{ paddingBottom: 20 }}>
              <TextField
                fullWidth
                disabled={disabledForm}
                name="sobrenome"
                label="Sobrenome"
                inputProps={{ id: "id_campo_sobrenome" }}
                value={formik.values.sobrenome}
                onChange={formik.handleChange}
                error={
                  formik.touched.sobrenome && Boolean(formik.errors.sobrenome)
                }
                helperText={formik.touched.sobrenome && formik.errors.sobrenome}
              />
            </Grid>
            <Grid item lg={12} md={12} xs={12} style={{ paddingBottom: 20 }}>
              <TextField
                fullWidth
                name="email"
                label="E-mail"
                disabled={disabledForm}
                inputProps={{ id: "id_campo_email" }}
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>
            <Grid item lg={12} md={12} xs={12}>
              <TextField
                fullWidth
                disabled={disabledForm}
                name="descricao"
                label="Descrição"
                variant="outlined"
                multiline
                inputProps={{ id: "id_campo_descricao" }}
                rows={4}
                value={formik.values.descricao}
                onChange={formik.handleChange}
                error={
                  formik.touched.descricao && Boolean(formik.errors.descricao)
                }
                helperText={formik.touched.descricao && formik.errors.descricao}
              />
            </Grid>
            <Grid item lg={12} style={{ paddingBottom: 20 }}>
              <Typography variant="h6">
                2. Exemplo campo de seleção unica tipo RADIO
              </Typography>
              <FormControl
                component="fieldset"
                error={
                  formik.touched.redeSocial && Boolean(formik.errors.redeSocial)
                }
              >
                <FormLabel component="legend">
                  Escolha uma rede social.
                </FormLabel>
                <RadioGroup
                  name="redeSocial"
                  value={formik.values.redeSocial}
                  data-testid="id_campo_redesSociais"
                  onChange={formik.handleChange}
                >
                  <FormControlLabel
                    value="1"
                    disabled={disabledForm}
                    control={<Radio id="id_Youtube" />}
                    label="Youtube"
                  />
                  <FormControlLabel
                    value="2"
                    disabled={disabledForm}
                    control={<Radio id="id_Linkedin" />}
                    label="Linkedin"
                  />
                  <FormControlLabel
                    value="3"
                    disabled={disabledForm}
                    control={<Radio id="id_Telegram" />}
                    label="Telegram"
                  />
                </RadioGroup>
                <FormHelperText>
                  {formik.touched.redeSocial && formik.errors.redeSocial}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid container lg={12} style={{ paddingBottom: 20 }}>
              <Typography variant="h6">
                4. Exemplo campo de seleção tipo SELECT (simples)
              </Typography>

              <Grid lg={12}>
                <FormHelperText>
                  Escolha uma linguagem de programação
                </FormHelperText>
                <select
                  name="linguagemProgramacaoSimples"
                  id="id_campo_linguagemProgramacaoSimples"
                  value={formik.values.linguagemProgramacaoSimples}
                  onChange={formik.handleChange}
                  style={{ width: "100%", height: 60 }}
                  disabled={disabledForm}
                >
                  <option value="">Selecione</option>
                  <option value="python" id="python">
                    PYTHON
                  </option>
                  <option value="c#" id="c#">
                    C#
                  </option>
                  <option value="javascript" id="javascript">
                    JAVASCRIPT
                  </option>
                </select>
                <FormHelperText
                  error={formik.touched.linguagemProgramacaoSimples}
                >
                  {formik.touched.linguagemProgramacaoSimples &&
                    formik.errors.linguagemProgramacaoSimples}
                </FormHelperText>
              </Grid>
            </Grid>
            <Grid container lg={12} style={{ paddingBottom: 20 }}>
              <Typography variant="h6">
                5. Exemplo campo de tipo SELECT (avançado){" "}
              </Typography>
              <FormControl fullWidth>
                <FormHelperText>
                  Escolha uma linguagem de programação
                </FormHelperText>
                <Select
                  disabled={disabledForm}
                  variant="outlined"
                  name="linguagemProgramacao"
                  inputProps={{
                    "data-testid": "id_campo_linguagemProgramacao",
                  }}
                  error={
                    formik.touched.linguagemProgramacao &&
                    Boolean(formik.errors.linguagemProgramacao)
                  }
                  value={formik.values.linguagemProgramacao}
                  onChange={formik.handleChange}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    <em>selecione</em>
                  </MenuItem>
                  <MenuItem value={0}>Python</MenuItem>
                  <MenuItem value={1}>Javascript</MenuItem>
                  <MenuItem value={2}>C#</MenuItem>
                </Select>
                <FormHelperText error={formik.touched.linguagemProgramacao}>
                  {formik.touched.linguagemProgramacao &&
                    formik.errors.linguagemProgramacao}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Typography variant="h6">
              6. Exemplo campo de seleção tipo SELECT múltiple (avançado)
            </Typography>
            <Grid container lg={12} style={{ paddingBottom: 20 }}>
              <FormHelperText>
                Escolha uma linguagem de programação
              </FormHelperText>

              <Autocomplete
                multiple
                fullWidth
                disabled={disabledForm}
                value={formik.values.multiplaSelecao}
                options={[
                  { title: "C#" },
                  { title: "PYTHON" },
                  { title: "JAVASCRIPT" },
                ]}
                getOptionSelected={(option, value) =>
                  option.title === value.title
                }
                onChange={(e, value) =>
                  formik.setFieldValue("multiplaSelecao", value)
                }
                getOptionLabel={(option) => option.title}
                data-testid="id_campo_multiplaSelecao"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={
                      formik.touched.multiplaSelecao &&
                      Boolean(formik.errors.multiplaSelecao)
                    }
                    name="multiplaSelecao"
                    variant="outlined"
                    helperText={
                      formik.touched.multiplaSelecao &&
                      formik.errors.multiplaSelecao
                    }
                    placeholder="Selecione"
                  />
                )}
              />
            </Grid>
            <Typography variant="h6">
              7. Exemplo campo de seleção múltipla tipo CHECKBOX
            </Typography>
            <Grid container lg={12} style={{ paddingBottom: 20 }}>
              <FormControl
                required
                component="fieldset"
                error={
                  formik.touched.ferramentas &&
                  Boolean(formik.errors.ferramentas)
                }
              >
                <FormLabel component="legend">
                  Escolha uma ou mais ferramenta (Opcional)
                </FormLabel>
                <FormGroup
                  name="ferramentas"
                  value={formik.values.ferramentas}
                  onChange={(e) => {
                    formik.setFieldValue("ferramentas", {
                      ...formik.values.ferramentas,
                      [e.target.name]: e.target.checked,
                    });
                  }}
                >
                  <FormControlLabel
                    disabled={disabledForm}
                    control={
                      <Checkbox
                        name="cypress"
                        id="id_checkbox_cypress"
                        checked={formik.values.ferramentas.cypress}
                      />
                    }
                    label="Cypress"
                  />
                  <FormControlLabel
                    disabled={disabledForm}
                    control={
                      <Checkbox
                        id="id_checkbox_selenium"
                        name="selenium"
                        checked={formik.values.ferramentas.selenium}
                      />
                    }
                    label="Selenium"
                  />
                  <FormControlLabel
                    disabled={disabledForm}
                    control={
                      <Checkbox
                        name="appium"
                        id="id_checkbox_appium"
                        checked={formik.values.ferramentas.appium}
                      />
                    }
                    label="Appium"
                  />
                  <FormControlLabel
                    disabled={disabledForm}
                    control={
                      <Checkbox
                        name="robotFramework"
                        id="id_checkbox_robotFramework"
                        checked={formik.values.ferramentas.robotFramework}
                      />
                    }
                    value={3}
                    label="Robot Framework"
                  />
                </FormGroup>
                <FormHelperText error={formik.touched.ferramentas}>
                  {formik.touched.ferramentas && formik.errors.ferramentas}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Typography variant="h6">
              8. Exemplo campo anexar arquivo.
            </Typography>
            <Grid container lg={12} style={{ paddingBottom: 20 }}>
              <Grid lg={12}>
                <FormLabel
                  component="legend"
                  style={{ padding: "10px 0 5px 0" }}
                >
                  Escolha um arquivo para anexar (Opcional)
                </FormLabel>
                <Grid>
                  <input
                    disabled={disabledForm}
                    accept="image/png"
                    type="file"
                    id="id_file"
                    data-testid="testId_file"
                    value={file?.value}
                    onChange={(file) =>
                      setFile({
                        value: file.target.value,
                        blob: file.target.files[0],
                      })
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              lg={12}
              spacing={2}
              style={{ padding: 10 }}
              justifyContent="flex-end"
            >
              <Grid item lg={3} md={4} xs={12}>
                <Button
                  fullWidth
                  color="secondary"
                  variant="outlined"
                  id="btn_reset"
                  data-testid="btn_reset"
                  onClick={() => {
                    setFile({
                      value: "",
                      blob: null,
                    });
                    setDisabledForm(false);
                    formik.resetForm();
                  }}
                >
                  Resetar
                </Button>
              </Grid>
              <Grid item lg={3} md={4} xs={12}>
                <Button
                  fullWidth
                  data-testid="btn_confirm"
                  color="primary"
                  variant="outlined"
                  type="submit"
                  disabled={disabledForm}
                  id="btn_confirm"
                >
                  Confirmar teste
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Grid>
      <ToastContainer icon={false} />
    </Grid>
  );
};
